export default "__VITE_ASSET__UutKBa2Y__"